// extracted by mini-css-extract-plugin
export var addButton = "_ib-0";
export var border = "_ib-8";
export var check = "_ib-h";
export var danger = "_ib-6";
export var dropdownContainer = "_ib-1";
export var editModalBody = "_ib-j";
export var footerContainer = "_ib-i";
export var fullWidth = "_ib-a";
export var hide = "_ib-9";
export var icon = "_ib-3";
export var input = "_ib-7";
export var inputFlex = "_ib-b";
export var inputWrapper = "_ib-c";
export var manualFocus = "_ib-5";
export var optionButton = "_ib-4";
export var pillWrapper = "_ib-e";
export var pointer = "_ib-2";
export var showOverflow = "_ib-f";
export var tagsFlex = "_ib-d";
export var xButton = "_ib-g";